import { render } from "./bitmap-link.vue?vue&type=template&id=387c2b64&ts=true"
import script from "./bitmap-link.vue?vue&type=script&lang=ts"
export * from "./bitmap-link.vue?vue&type=script&lang=ts"

import "./bitmap-link.vue?vue&type=style&index=0&id=387c2b64&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__